import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Country} from '../../../kf-data-entry/models/country.interface';
import {DownloadDataService} from '../../services/download-data.service';
import {IntelligenceService} from '../../../intelligence/services/intelligence.service';
import {WeeeSystems} from '../../../admin/models/weee_systems.interface';
import {MatOption} from '@angular/material/core';
import {saveAs} from 'file-saver';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-download-data-dialog',
  templateUrl: './download-data-dialog.component.html',
  styleUrls: ['./download-data-dialog.component.scss']
})
export class DownloadDataDialogComponent implements OnInit, AfterViewInit {

  years!: number[];
  countries!: Country[];
  weeeSystems!: WeeeSystems[];


  downloadDataForm = this.formBuilder.group({
    years: ['', this.type === 'intelligence' ? Validators.required : ''],
    countries: [''],
  });

  get yearsControl(): FormControl {
    return this.downloadDataForm.get('years') as FormControl;
  }

  get countriesControl(): FormControl {
    return this.downloadDataForm.get('countries') as FormControl;
  }

  downloadIntelligenceDataForm = this.formBuilder.group({
    countries: [''],
    weeeSystems: [''],
  });

  get countriesIntelligenceDataControl(): FormControl {
    return this.downloadIntelligenceDataForm.get('countries') as FormControl;
  }

  get weeeSystemsIntelligenceDataControl(): FormControl {
    return this.downloadIntelligenceDataForm.get('weeeSystems') as FormControl;
  }

  @ViewChild('allSelected') private allSelected!: MatOption;
  @ViewChild('allCountrySelected') private allCountrySelected!: MatOption;
  @ViewChild('allWeeeSystemsSelected') private allWeeeSystemsSelected!: MatOption;

  constructor(private dialogRef: MatDialogRef<DownloadDataDialogComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly downloadDataService: DownloadDataService,
              private readonly intelligenceService: IntelligenceService,
              private readonly authService: AuthService,
              @Inject(MAT_DIALOG_DATA) public type: string) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (this.type === 'intelligence') {
      this.intelligenceService.getYears().subscribe(data => {
        this.years = data;
        this.yearsControl.setValue(data[0]);
      });
    }
    if (this.type === 'intelligencereporting') {
      this.downloadDataService.getAllWeeeSystems().subscribe(data => {
        this.weeeSystems = data;
        this.allWeeeSystemsSelected.select();
        this.toggleAllSystemsSelected();
      });
    }
    if (this.allSelected) {
      this.downloadDataService.getAllYears().subscribe(data => {
        this.years = data;
        this.allSelected.select();
        this.toggleAllYearsSelection();
      });
    }
    if (this.allCountrySelected) {
      this.downloadDataService.getAllCountries().subscribe(data => {
        this.countries = data.filter(x=>x.status == 'ACTIVE');
        this.allCountrySelected.select();
        this.toggleAllCountriesSelected();
      });
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  toggleYearPerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.yearsControl.value.length === this.years.length) {
      this.allSelected.select();
    }

  }

  toggleCountryPerOne(): void {
    if (this.allCountrySelected.selected) {
      this.allCountrySelected.deselect();
      return;
    }
    if (this.countriesControl.value.length === this.countries.length) {
      this.allCountrySelected.select();
    }
  }

  toggleCountryIntelligencePerOne(): void {
    if (this.allCountrySelected.selected) {
      this.allCountrySelected.deselect();
      return;
    }
    if (this.countriesIntelligenceDataControl.value.length === this.countries.length) {
      this.allCountrySelected.select();
    }
  }

  toggleAllYearsSelection(): void {
    if (this.allSelected.selected) {
      this.yearsControl
        .patchValue([...this.years.map(item => item), 0]);
    } else {
      this.yearsControl.patchValue([]);
    }
  }

  toggleAllCountriesSelected(): void {
    if (this.allCountrySelected.selected) {
      this.type === 'intelligencereporting' ?
        this.countriesIntelligenceDataControl
          .patchValue([...this.countries.map(item => item.id), 0]) :
        this.countriesControl
          .patchValue([...this.countries.map(item => item.id), 0]);
    } else {
      this.type === 'intelligencereporting' ?
        this.countriesIntelligenceDataControl.patchValue([]) :
        this.countriesControl.patchValue([]);
    }
  }

  toggleAllSystemsSelected(): void {
    if (this.allWeeeSystemsSelected.selected && this.type) {
      this.weeeSystemsIntelligenceDataControl
        .patchValue([...this.weeeSystems.map(item => item.id), 0]);
    } else {
      this.weeeSystemsIntelligenceDataControl.patchValue([]);
    }
  }

  downloadData(): void {
    if (this.type === 'intelligence') {
      this.downloadDataService
        .downloadIntelligenceExcel({years: this.yearsControl.value, countries: this.countriesControl.value})
        .subscribe(response => {
          this.downloadFile(response, `country_system_at_a_glance-${new Date(Date.now()).toISOString()}.xlsx`);
        });
    } else if (this.type === 'intelligencereporting') {
      this.downloadDataService
        .downloadIntelligenceDataExcel(
          {countries: this.countriesIntelligenceDataControl.value, weeeSystems: this.weeeSystemsIntelligenceDataControl.value})
        .subscribe(response => {
          this.downloadFile(response, `intelligence_reporting-${new Date(Date.now()).toISOString()}.xlsx`);
        });
    } else {
      this.downloadDataService
        .downloadExcel({years: this.yearsControl.value, countries: this.countriesControl.value})
        .subscribe(response => {
            const userSystem = this.authService.getSystem();
            this.downloadFile(response, `kf_data-${userSystem ? userSystem + '-' : ''}${new Date(Date.now()).toISOString()}.xlsx`);
          }
        );
    }
  }

  private downloadFile(response: any, filename: string): void {
    const blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    saveAs(blob, filename);
  }
}
